import {gsap, Expo} from 'gsap';
import { VisualSlides } from './'

export default class {
  constructor(el) {
    this.dom = {el: el}
    // this.dom.loader = this.dom.el.querySelector('[data-js="loader"]');
    this.dom.ci = this.dom.el.querySelector('[data-js="ci"]');
    this.dom.copy = this.dom.el.querySelector('[data-js="copy"]');
    this.dom.slide = document.querySelector('[data-js="slide"]');
    this.dom.visual = document.querySelector('[data-js="visual-slide"]');

    this.visualSlider = null;

    this.init();
  }

  init() {
    const _this = this;

    if (this.dom.visual) {
      this.visualSlider = new VisualSlides(this.dom.visual);
    }

    setTimeout(el=>{
      _this.dom.el.dataset.opening = 'start';
    }, 300);

    // this.dom.loader.addEventListener('transitionend', ()=>{
    // })
    const tl = gsap.timeline({ repeat: 0, repeatDelay: 0 });
    tl.to(this.dom.ci, {
      y: 0,
      scale: 1,
      opacity: 1,
      duration: 0.5,
      delay: 1.5,
      ease: 'power4.out'
    }),
    tl.to('[data-scene="01"]', {
      clipPath: 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)',
      duration: 1,
      delay: 1,
      ease: 'power4.out'
      // onComplete: ()=>{
      //   gsap.to(this.dom.loader, {opacity: 0, duration: 0});
      // }
    }),
    tl.fromTo(this.dom.copy, {
      x: '-1rem',
      opacity: 0
    },{
      x: 0,
      scale: 1,
      opacity: 1,
      duration: 1,
      ease: 'power4.out',
      onComplete: ()=>{
        window.scroll({top: 0, behavior: 'instant'});
      }
    }, '-=0.75'),
    tl.to('[data-scene="02"]', {
      clipPath: 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)',
      duration: 1.25,
      delay: 1.25,
      ease: 'power3.inOut',
      onStart: ()=>{
        document.body.dataset.opening = 'finished';
      },
      onComplete: ()=>{
        this.dom.el.remove();
        if (this.dom.visual) this.visualSlider.play();
      }
    }),
    tl.fromTo(this.dom.slide, {
      x: '-5rem'
    },{
      x: 0,
      duration: 2,
      ease: 'power1.Out',
    }, '-=2')
  }
}
